import 'phaser';
import { Utils } from './app/utils';
import Game from './app/game';
import MainMenu from './app/mainmenu'
import NormalMode from './app/normalmode';
import RushMode from './app/rushmode';
import Tutorial from './app/tutorial';
import UI from './app/ui';
import { SDKManager } from './libs/sdkManager';
import { Localisation } from './libs/Localisation';


type scaleMode = 'FIT' | 'SMOOTH'
export enum BUILD_TYPE { GENERIC = 0, FB = 1 }

export default class App {
    public static BUILDTYPE: BUILD_TYPE = BUILD_TYPE.GENERIC;

    public static MAX_WIDTH: number = 1080;
    public static MAX_HEIGHT: number = 2160;

    public static DEFAULT_WIDTH: number = 1000;
    public static DEFAULT_HEIGHT: number = 2100;

    public static MAX_WIDTH_HALF: number = App.MAX_WIDTH / 2;
    public static MAX_HEIGHT_HALF: number = App.MAX_HEIGHT / 2;

    public static APP_WIDTH: number = 1080;
    public static APP_HEIGHT: number = 2160;

    public static MAX_BROWSER_WIDTH: number = 1619; // Fix for letterboxing issue

    public static SCALE_MODE: scaleMode = 'SMOOTH';

    public app: App;

    public static _instance: App;
    public static _game: Phaser.Game;

    public static BGM: Phaser.Sound.BaseSound; // Background music played throughout
    public static MUTE: boolean = false;
    public static TUTORIAL_SHOWN: boolean = false; // Has tutorial been shown yet
    public static FIRST_TIME: boolean = false; // Has tutorial been shown yet
    public static AD_SHOWN: boolean = false; // Has ad been shown yet
    public static AD_TIME: number = 5; // Time (in sceonds) for player to click on ad
    public static POWERUP_TIME: number = 4500; // Time (in milliseconds) for which power up lasts 
    public static RUSH_MODE_TIME: number = 5200; // Time (in milliseconds) for which rush mode (bonus level) lasts 
    public static GAME_DROP_SPEED: number = 4000; // Player drop speed in normal game mode (set as gravity of scene)
    public static RUSH_MODE_DROP_SPEED: number = 12000; // Player drop speed in rush mode (bonus level) (set as gravity of scene)

    public static SDK: SDKManager;
    public static UI: UI;

    public static meta: any = null;
    public static metaLength: number = 10; // Change according to meta.
    public static metaInitial: any = {
        0: { status: 1, cost: 0 },
        1: { status: -1, cost: 500 },
        2: { status: -1, cost: 500 },
        3: { status: -1, cost: 500 },
        4: { status: -1, cost: 1000 },
        5: { status: -1, cost: 1000 },
        6: { status: -1, cost: 1000 },
        7: { status: -1, cost: 1500 },
        8: { status: -1, cost: 1500 },
        9: { status: -1, cost: 1500 }
    }; // Status: -1 = Not Purchased, 0 = Purchased but not Equipped, 1 = Currently Selected or Equipped
    public static highScore: number = 0;
    public static stars: number = 0;

    public static maxLives: number = 3;
    public static lives: number = 3;
    public static characters: Array<any> = new Array<any>(5);
    public static languages: Array<any> = new Array<any>(3);
    public static characterIndex: number = 0;
    public static langIndex: number = 0;
    public static languageSet: boolean = true;
    public static revieved: boolean = false;

    constructor() {
        ;
        this.processParams();
        App._instance = this;
        //App._game = new Phaser.Game(config);
        switch (App.BUILDTYPE) {
            case BUILD_TYPE.GENERIC:
                App.SDK = new SDKManager();
                App.UI = new UI();
                break;                
            case BUILD_TYPE.FB:
                App.SDK = new SDKManager();
                App.UI = new UI();
                break;
        }
    }

    public static GetParam(key: string) {
        if (key in App._instance.params) {
            return App._instance.params[key];
        }

        return null;
    }

    public static vibrate(duration: number) {
        if (navigator.userAgent.indexOf("Android") != -1) {
            window.navigator.vibrate(duration);
        }
    }

    private params = {};

    private processParams() {
        this.params = {};
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            this.params[pair[0]] = decodeURIComponent(pair[1]);
        }
    }

    public static ViewportToAppView(viewportPoint: Point): Point {
        return new Point(

            Utils.Interpolate(viewportPoint.x, 0, 1, 0, App.APP_WIDTH),
            Utils.Interpolate(viewportPoint.y, 0, 1, 0, App.APP_HEIGHT),
        );
    }

}

window.addEventListener('resize', () => {
    var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)
    if(isMobile != null){
        if (window.screen.width < window.screen.height) {
            document.getElementById("wrongRotation").style.display = "none";
        } else {
            document.getElementById("wrongRotation").style.display = "block";
        }
    }
});

const config = {
    type: Phaser.AUTO,
    transparent: true,

    scale: {
        parent: 'phaser-game',
        mode: Phaser.Scale.NONE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: App.DEFAULT_WIDTH,
        height: App.DEFAULT_HEIGHT
    },
    input: {
        activePointers: 1,
    },
    scene: [Game, MainMenu, NormalMode, RushMode, Tutorial, UI]
};

const app = new App();


window.addEventListener('load', () => {
    //return;
    const game = new Phaser.Game(config)

    const resize = () => {
        //return;
        const w = window.innerWidth
        const h = window.innerHeight

        let width = App.DEFAULT_WIDTH
        let height = App.DEFAULT_HEIGHT
        let maxWidth = App.MAX_BROWSER_WIDTH
        let maxHeight = App.MAX_HEIGHT
        let scaleMode = App.SCALE_MODE;

        let scale = Math.min(w / width, h / height)
        let newWidth = Math.min(w / scale, maxWidth)
        let newHeight = Math.min(h / scale, maxHeight)

        let defaultRatio = App.DEFAULT_WIDTH / App.DEFAULT_HEIGHT
        let maxRatioWidth = App.MAX_BROWSER_WIDTH / App.DEFAULT_HEIGHT
        let maxRatioHeight = App.DEFAULT_WIDTH / App.MAX_HEIGHT

        // smooth scaling
        let smooth = 1
        if (scaleMode === 'SMOOTH') {
            const maxSmoothScale = 1.15
            const normalize = (value: number, min: number, max: number) => {
                return (value - min) / (max - min)
            }
            if (width / height < w / h) {
                smooth =
                    -normalize(newWidth / newHeight, defaultRatio, maxRatioWidth) / (1 / (maxSmoothScale - 1)) + maxSmoothScale
            } else {
                smooth =
                    -normalize(newWidth / newHeight, defaultRatio, maxRatioHeight) / (1 / (maxSmoothScale - 1)) + maxSmoothScale
            }
        }

        // resize the game
        game.scale.resize(newWidth * smooth, newHeight * smooth);

        // scale the width and height of the css
        game.canvas.style.width = newWidth * scale + 'px'
        game.canvas.style.height = newHeight * scale + 'px'

        // center the game with css margin
        game.canvas.style.marginTop = `${(h - newHeight * scale) / 2}px`
        game.canvas.style.marginLeft = `${(w - newWidth * scale) / 2}px`
    }

    window.addEventListener('resize', event => {
        resize()
    })

    resize();
})

export class Point {
    public x: number;
    public y: number;

    constructor(x: number = 0, y: number = 0) {
        this.x = x;
        this.y = y;
    }
}

